var React = require('react');

function WaveTopBalanced (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-0.18866 23.3c23.983 12.951 75.014 22.312 102.55 14.154 27.536-8.1576 47.703-22.179 110.9-25.467v-12.745h-213.45z","fill":"#fff"}));
}

WaveTopBalanced.defaultProps = {"width":"800","height":"200","preserveAspectRatio":"none","version":"1.1","viewBox":"0 0 211.67 52.917"};

module.exports = WaveTopBalanced;

WaveTopBalanced.default = WaveTopBalanced;
